import React from "react";

const LeftArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
    >
      <path
        d="M5.6749 12.2205C5.98086 12.5219 6.47327 12.5183 6.77473 12.2123C7.07619 11.9064 7.07254 11.414 6.76659 11.1125L2.58997 6.9973L13.2223 6.9973C13.6518 6.9973 14 6.64911 14 6.21958C14 5.79006 13.6518 5.44187 13.2223 5.44187L2.59511 5.44187L6.76659 1.33172C7.07254 1.03026 7.07619 0.537854 6.77473 0.231895C6.47327 -0.0740633 5.98086 -0.0777092 5.6749 0.22375L0.289845 5.52963C-0.0966139 5.91041 -0.0966139 6.53382 0.289845 6.9146L5.6749 12.2205Z"
        fill="#7B7B7B"
      />
    </svg>
  );
};

export default LeftArrowIcon;
